import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { RealBizTypeSelect as LocalRealBizTypeSelect } from '../../components/RealBizTypeSelect'

export const RealBizTypeSelect = connect(
  LocalRealBizTypeSelect,
  mapReadPretty(LocalRealBizTypeSelect, {
    disabled: true
  })
)
